import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
// import { NativeAudio } from '@ionic-native/native-audio';

import { ConfigService } from '../config.service';
import { BaseService } from 'ngx-elvis-ds';

interface Sound {
  key: string;
  asset: string;
  isNative: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SoundService extends BaseService {

  private sounds: Sound[] = [];
  private audioPlayer: HTMLAudioElement = new Audio();
  private forceWebAudio = true;

  constructor(
    private platform: Platform,
    private configSvc: ConfigService
  ) {
    super();
  }

  init() {
    this.preload('jingle', 'assets/audio/jingle.mp3');
    this.preload('danger', 'assets/audio/danger.mp3');
    this.preload('warning', 'assets/audio/warning.mp3');
    this.preload('success', 'assets/audio/success.mp3');
    this.preload('click', 'assets/audio/click.mp3');
    this.preload('barcode-scanner', 'assets/audio/barcode-scanner.mp3');

    
  }

  preload(key: string, asset: string): void {
    const audio = new Audio();
    audio.src = asset;
    this.sounds.push({ key: key, asset: asset, isNative: false });
  }

  async play(key: string) {
    try {
      if (key !== '') {
        const soundToPlay = this.sounds.find(sound => sound.key === key );
        if (soundToPlay && this.configSvc.guiSettings.enableSound) {
          if (soundToPlay.isNative) {
            // this.nativeAudio.play(soundToPlay.asset).then((res) => {
            //   console.log(res);
            // }, (err) => {
            //   console.log(err);
            // });
          } else {
            this.audioPlayer.src = soundToPlay.asset;
            this.audioPlayer.play();
          }
        }
      }
    } catch (error) {
    }
  }
}
